import { Box } from "@mui/material";
import * as CSS from "csstype";
import { ReactNode } from "react";

export type ElementToPrint = {
  name: string;
  value: string | ReactNode;
  top: string;
  left: string;
  fontSize?: string;
  height?: string;
  width?: string;
  textWrap?: "wrap" | "nowrap" | "balance" | "stable" | "pretty";
  fontWeight?: CSS.Property.FontWeight | string;
  textAlight?: CSS.Property.TextAlign;
  fontStyle?: CSS.Property.FontStyle;
  lineHeight?: CSS.Property.LineHeight;
  textIndent?: CSS.Property.TextIndent;
  lineClamp?: string;
  textColor?: CSS.Property.Color;
};
type ElementProps = {
  element: ElementToPrint;
};
export const Element = ({ element }: ElementProps) => {
  return (
    <Box
      sx={{
        top: element.top,
        left: element.left,
        position: "absolute",
        zIndex: "10",
        fontSize: element.fontSize,
        height: element.height ? element.height : "auto",
        width: element.width ? element.width : "auto",
        overflow: "hidden",
        textOverflow: "ellipsis",
        // whiteSpace: "pre",
        display: "-webkit-box",
        textWrap: element.textWrap ? element.textWrap : "nowrap",
        whiteSpace: element.textWrap === "nowrap" ? "nowrap" : "normal",
        "-webkit-line-clamp": element.lineClamp ? element.lineClamp : undefined,
        "-webkit-box-orient": "vertical",
        backgroundColor:
          process.env.NODE_ENV === "development"
            ? "rgba(38, 237, 73, 0.2)"
            : undefined,
        minHeight: process.env.NODE_ENV === "development" ? "24px" : undefined,

        fontWeight: element.fontWeight,
        textAlign: element.textAlight,
        fontStyle: element.fontStyle,
        textIndent: element.textIndent,
        lineHeight: element.lineHeight ? element.lineHeight : undefined,
        color: element.textColor,
      }}
    >
      {element.value}
    </Box>
  );
};
